import React from "react";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import Tabs from "components/molecules/Tabs";
import SubscriptionPointPanel from "./SubscriptionPointPanel";
import OrdersPage from "../Orders";
import ReportUsagePage from "./ReportUsage";
import FaqTab from "./FaqTab";

const TABS = [
  { id: "pricing", label: "멤버십·포인트 현황" },
  { id: "payments", label: "포인트·구독 내역" },
  { id: "reports", label: "보고서 사용 내역" },
  { id: "faq", label: "FAQ" },
];

const VALID_TABS = TABS.map((t) => t.id);

const BillingPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("tab");
  const tab = param && VALID_TABS.includes(param) ? param : "pricing";

  const handleTabChange = (id: string) => {
    setSearchParams({ tab: id });
  };

  return (
    <Container>
      <TabBarWrap>
        <Tabs tabs={TABS} activeTab={tab} onTabChange={handleTabChange} />
      </TabBarWrap>
      <Content>
        {tab === "pricing" && <SubscriptionPointPanel />}
        {tab === "payments" && <OrdersPage />}
        {tab === "reports" && <ReportUsagePage />}
        {tab === "faq" && <FaqTab />}
      </Content>
    </Container>
  );
};

export default BillingPage;

const Container = styled.div`
  width: 100%;
`;

const TabBarWrap = styled.div`
  padding: 16px 40px 0;
`;

const Content = styled.div`
  width: 100%;
  padding: 24px 40px 40px;
`;
